import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';

/** 获取运行时视图配置 */
export const getViewSetting = (params: H3.View.Runtime.Request.IGetViewSettingModel) =>
    request<H3.Http.Response.H3Response<H3.View.Runtime.Response.IMainViewSettingPage>>(Api.GetViewSetting, {
        method: 'get',
        params,
    });

/** 加载视图设计器 */
export const loadViewDesignData = (params: { schemaCode: string }) =>
    request<H3.Http.Response.H3Response<H3.View.ViewDesigner.Response.ILoadDesignerViewModel[]>>(Api.LoadViewDesigner, {
        method: H3.Http.MethodType.GET,
        params,
    });

/** 保存视图设计器 */
export const saveViewDesignData = (params: H3.View.ViewDesigner.Request.ISaveDesignerViewModel) =>
    request<H3.Http.Response.H3Response<boolean>>(Api.SaveViewDesigner, {
        method: H3.Http.MethodType.POST,
        data: params,
        disableBizError: true,
    });

/** 单独保存列表设计器按钮 */
export const saveViewDesignActions = (params: H3.View.ViewDesigner.Request.ISaveDesignerViewActionsModel) =>
    request<H3.Http.Response.H3Response<boolean>>(Api.SaveViewDesignerActions, {
        method: H3.Http.MethodType.POST,
        data: params,
        disableBizError: true,
    });

/** 获取视图配置标签页 */
export const getViewSettingPageList = (params: { schemaCode: string }) =>
    request<H3.Http.Response.H3Response<H3.View.Runtime.Response.IRuntimeViewSettingPage[]>>(
        Api.GetViewSettingPageList,
        {
            method: H3.Http.MethodType.GET,
            params,
        },
    );

/** 获取视图偏好配置 */
export const getViewPreference = (params: H3.View.Runtime.Request.IGetViewPreferenceModel) =>
    request<H3.Http.Response.H3Response<H3.View.IPreferenceItem[]>>(Api.GetViewPreference, {
        method: 'get',
        params,
    });

/** 新增视图偏好配置 */
export const addViewPreference = (params: H3.View.Runtime.Request.IAddViewPreferenceModel) =>
    request<H3.Http.Response.H3Response<string>>(Api.AddViewPreference, {
        method: 'post',
        data: params,
    });

/** 更新视图偏好配置 */
export const updateViewPreference = (params: H3.View.Runtime.Request.IUpdateViewPreferenceModel) =>
    request<H3.Http.Response.H3Response<boolean>>(Api.UpdateViewPreference, {
        method: 'post',
        data: params,
    });

/** 删除视图偏好配置 */
export const removeViewPreference = (params: H3.View.Runtime.Request.IRemoveViewPreferenceModel) =>
    request<H3.Http.Response.H3Response<boolean>>(Api.RemoveViewPreference, {
        method: 'post',
        data: params,
    });

/** 对视图偏好排序 */
export const sortViewPreference = (params: H3.View.Runtime.Request.ISortViewPreferenceModel) =>
    request<H3.Http.Response.H3Response<boolean>>(Api.SortViewPreference, {
        method: 'post',
        data: params,
    });

/** 设计时校验是否可以开启层级视图 */
export const checkHierarchyField = (params: { schemaCode: string }) => {
    return request<H3.Http.Response.H3Response<H3.View.Runtime.Response.TCheckHierarchyViewField>>(
        Api.CheckHierarchyLimit,
        {
            method: 'get',
            params,
        },
    );
};

/** 获取列表视图默认列 */
export const loadListViewDefaultColumns = (params: { schemaCode: string }) =>
    request<H3.Http.Response.H3Response<string[]>>(Api.LoadListViewDefaultColumns, {
        method: 'get',
        params,
    });

/** 获取视图按钮 */
export const loadViewActionList = (params: { schemaCode: string }) =>
    request<H3.Http.Response.H3Response<H3.View.IAction[]>>(Api.LoadViewActionList, {
        method: H3.Http.MethodType.GET,
        params,
    });
